export default __webpack_public_path__ + "static/media/Iconly-Bulk-Location.66ad8a6f.svg";